








































































































import loginCore, { LoginResult } from './login.core'
import { Component, Mixins, Ref } from 'vue-property-decorator'
import LoginDialogModule from '@/portal/store/login/LoginDialogModule'
import { ElForm } from 'element-ui/types/form'

@Component
export default class extends Mixins(loginCore) {
  @Ref('elForm')
  elForm: ElForm
  passwordLogin = true
  logged = false
  loginIng = false
  isCaptchaValid = false

  toggleTab(flag: boolean) {
    this.refreshValidateCodePic()
    this.passwordLogin = flag
  }

  async login() {
    this.elForm.validate(async valid => {
      if (valid) {
        this.loginIng = true
        let result: any
        try {
          if (!this.passwordLogin) {
            result = await this.shortMessageLogin()
          } else {
            result = await this.doPasswordLogin()
          }
          if (result.status.isSuccess()) {
            try {
              await this.$authentication.auth()
              this.stopTimerCount()
              this.$emit('login-result', true)
            } catch (e) {
              this.loginIng = false
            }
          }
        } catch (e) {
          this.loginResult = new LoginResult(e.code, e.message)
          if (this.loginResult.code === 4100) {
            await this.refreshValidateCodePic()
          }
        } finally {
          this.loginIng = false
        }
      } else {
        return false
      }
    })
  }

  toRegistry() {
    this.$emit('go-registry')
  }

  toForgot() {
    this.$emit('go-forget-password')
  }

  close() {
    this.$emit('loginClose')
    LoginDialogModule.setShowLoginDialog(false)
  }
}
